import Dashboard from "./Dashboard"

export default  Dashboard;



// WEBPACK FOOTER //
// ./src/components/App/Dashboard/index.js